import {
  GET_LEGAL_CHANGES,
  SET_LEGAL_CHANGES,
  SET_NEW_LEGAL_CHANGES,
  GET_LEGAL_CHANGES_ERROR,
  SET_LEGAL_CHANGE_FILTERS,
  RESET_LEGAL_CHANGE_FILTERS
} from './types'
import axios from 'axios'
import Config from 'config'
import store from 'store'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { createLatestRequest } from 'helpers/latestRequest'
import {
  replaceByTargetFromArray,
  handleTZOffset
} from 'helpers/dataHelpers'


const { apiUrl } = Config.network


const startLegalChangesRequest = createLatestRequest()

export function getLegalChanges(next, domain, room, sorting, search, parent, dateRange, status) {
  return function action(dispatch) {
    const { cancelToken, isStale } = startLegalChangesRequest()
    dispatch({
      type: GET_LEGAL_CHANGES
    })
    const url = next || `${apiUrl}legal-changes/`
    const params = {}
    if (parent) {
      params['parent'] = parent
    }
    if (domain) {
      params['domain'] = domain
    }
    if (room && room.length > 0) {
      params['room'] = room.join()
    }
    if (sorting) {
      params['sorting'] = sorting
    }
    if (search) {
      params['search'] = search
    }
    if (dateRange && dateRange['startDate']) {
      params['startDate'] = handleTZOffset(dateRange['startDate'])
    }
    if (dateRange && dateRange['endDate']) {
      params['endDate'] = handleTZOffset(dateRange['endDate'])
    }
    if (status) {
      params['status'] = status
    }
    axios.get(url, { params, cancelToken }).then((body) => {
      if (isStale()) {
        return
      }
      const { data } = body
      if (next) {
        const { legalChanges } = store.getState().legalChanges
        dispatch({
          type: SET_LEGAL_CHANGES,
          payload: {
            legalChanges: [...legalChanges, ...data.results],
            legalChangesNext: data.next,
            newLegalChangesCount: data.new_count
          }
        })
      } else {
        dispatch({
          type: SET_LEGAL_CHANGES,
          payload: {
            legalChanges: data.results,
            legalChangesNext: data.next,
            newLegalChangesCount: data.new_count
          }
        })
      }
    }).catch(error => {
      if (axios.isCancel(error) || isStale()) {
        return
      }
      dispatch({
        type: GET_LEGAL_CHANGES_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function updateLegalChangeByTarget(target) {
  return function action(dispatch) {
    const { legalChangesNext, legalChanges, newLegalChangesCount } = store.getState().legalChanges
    let currentLegalChanges = replaceByTargetFromArray(legalChanges, target)
    dispatch({
      type: SET_LEGAL_CHANGES,
      payload: {
        legalChanges: currentLegalChanges,
        legalChangesNext: legalChangesNext,
        newLegalChangesCount: newLegalChangesCount
      }
    })
  }
}

export function getNewLegalChangesCount() {
  return function action(dispatch) {
    const url = `${apiUrl}legal-changes/get_unread/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
        dispatch({
          type: SET_NEW_LEGAL_CHANGES,
          payload: {
            newLegalChangesCount: data.new_count
          }
        })
    }).catch(error => {
      dispatch({
        type: GET_LEGAL_CHANGES_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function setReadLegalChange() {
  return function action(dispatch) {
    const { newLegalChangesCount } = store.getState().legalChanges
    dispatch({
      type: SET_NEW_LEGAL_CHANGES,
      payload: {
        newLegalChangesCount: newLegalChangesCount - 1
      }
    })
  }
}

export function setLegalChangeFilters(filters) {
  return {
    type: SET_LEGAL_CHANGE_FILTERS,
    payload: {
      filters
    }
  }
}

export function resetLegalChangeFilters() {
  return {
    type: RESET_LEGAL_CHANGE_FILTERS
  }
}
